import { createRef, FC, PropsWithChildren } from "react";
import cn from "classnames";
import { Trans } from "@lingui/macro";
import {
  connectCurrentRefinements,
  CurrentRefinementsProvided,
  Refinement,
  SearchState,
} from "react-instantsearch-core";
import { useLockBodyScroll } from "src/hooks/useLockBodyScroll";
import { LabelNavigation } from "src/molecules/LabelNavigation";
import {
  ArrowLeft,
  Content,
  DrawerButton,
  Wrapper,
} from "./DrawerFilter.styled";
import { CATEGORIES_FACET } from "src/utils/algolia";
import { filterFacets } from "src/organisms/AlgoliaProductList/utils/filterFacets";
import { MessageDescriptor } from "@lingui/core";

interface RefinementsProps extends CurrentRefinementsProvided {
  selectedFacet: string;
  genderId: string;
  setStatePayload?: (
    payload: SearchState & { selectedCatSlug: string[] }
  ) => void;
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  selectedCatSlug?: string[];
}

const Refinements: FC<RefinementsProps> = ({
  items,
  refine,
  selectedFacet,
  setStatePayload,
  keepSelectedIgnoreInActive,
  selectedCatSlug,
}) => {
  let facetToRefine: Refinement[] = [];

  facetToRefine = items.filter((item) => {
    return (
      item.attribute === selectedFacet &&
      filterFacets(item, keepSelectedIgnoreInActive, selectedCatSlug)
    );
  });

  if (
    selectedFacet === CATEGORIES_FACET &&
    setStatePayload &&
    facetToRefine.length
  ) {
    return (
      <DrawerButton
        onClick={(e) => {
          e.stopPropagation();
          setStatePayload({
            refinementList: { [CATEGORIES_FACET]: [] },
            selectedCatSlug: [],
          });
        }}
      >
        <Trans>Clear all</Trans>
      </DrawerButton>
    );
  } else if (facetToRefine.length && selectedFacet !== CATEGORIES_FACET) {
    return (
      <DrawerButton
        onClick={(e) => {
          e.stopPropagation();
          refine(facetToRefine);
        }}
      >
        <Trans>Clear all</Trans>
      </DrawerButton>
    );
  } else {
    return null;
  }
};

const ClearRefinement = connectCurrentRefinements(Refinements);

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title?: MessageDescriptor;
  selectedFacet: string;
  genderId: string;
  setStatePayload?: (
    payload: SearchState & { selectedCatSlug: string[] }
  ) => void;
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  selectedCatSlug?: string[];
}

const DrawerFilter: FC<PropsWithChildren<Props>> = ({
  children,
  isOpen,
  onClose,
  title,
  selectedFacet,
  genderId,
  setStatePayload,
  keepSelectedIgnoreInActive,
  selectedCatSlug,
}) => {
  const drawerContainer = createRef<HTMLDivElement>();
  useLockBodyScroll(isOpen);

  return (
    <Wrapper ref={drawerContainer} className={cn({ Drawer_open: isOpen })}>
      <Content>
        <LabelNavigation
          label={title}
          leftAdornment={<ArrowLeft strokeWidth="2" />}
          rightAdornment={
            <ClearRefinement
              genderId={genderId}
              selectedFacet={selectedFacet}
              setStatePayload={setStatePayload}
              keepSelectedIgnoreInActive={keepSelectedIgnoreInActive}
              selectedCatSlug={selectedCatSlug}
            />
          }
          onClick={onClose}
        />
        {children}
      </Content>
    </Wrapper>
  );
};

export default DrawerFilter;
